import React from "react";
import Form from "../../componets/Form";

const Section10 = () => {
  return (
    <div className="mt-[-100px] md:mt-[-3%]">
      <Form />
    </div>
  );
};

export default Section10;
